import {TemplateList} from "~/libs/constants/TemplateList"

export const CncSimpleArtobjectAllowedProviders: Record<TemplateList, string[]> = {
  [TemplateList.POGGERS]: [],
  [TemplateList.MATERIDOUSKA]: [],
  [TemplateList.HEYFOMO]: ['Instagram', 'YouTube', 'TikTok', 'Twitter', 'Spotify', 'Pinterest'],
}
